import { render, staticRenderFns } from "./ChevronDown.vue?vue&type=template&id=28195ab5&scoped=true&"
import script from "./ChevronDown.vue?vue&type=script&lang=js&"
export * from "./ChevronDown.vue?vue&type=script&lang=js&"
import style0 from "./ChevronDown.vue?vue&type=style&index=0&id=28195ab5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28195ab5",
  null
  
)

export default component.exports